import { getConfig } from "@/app/config/config";
import { tracedFetch } from "../tracing";
export async function uploadUserPhoto(
    userUid: string,
    imageData: Blob | File,
    fileName: string = 'test-photo.jpg',
    securityToken: string
): Promise<Response> {
    let config = await getConfig();

    const formData = new FormData();
    formData.append('file', imageData, fileName);

    // Add avatar SDK configuration
    const avatarSdkConfiguration = {
        pipeline: 'head_2.0',
        pipeline_subtype: 'head/mobile',
        parameters: {
            model_info: {
                plus: [
                    "gender",
                    "age",
                    "race",
                    "hair_color",
                    "eye_iris_color"
                ]
            },
            avatar_modifications: {
                plus: {
                    remove_smile: true,
                    remove_glasses: true,
                    enhance_lighting: true
                }
            }
        },
        export_parameters: {
            format: "glb",
            embed: true,
            embed_textures: true,
            texture_size: {
                width: 2048,
                height: 2048
            },
            lod: 5,
            blendshapes: {
                list: [
                    "mobile_51",
                    "visemes_15"
                ],
                embed: true
            },
            haircuts: {
                list: [
                    'generated'
                ],
                embed: true
            }
        }
    };

    // Convert configuration to JSON Blob and append as file
    const configBlob = new Blob([JSON.stringify(avatarSdkConfiguration)], { type: 'application/json' });
    formData.append('avatarSdkConfiguration', configBlob, 'config.json');

    // Hard-coded customizationUid
    const customizationUid = '0199c85f-1a56-712b-9359-e7b8fb882872';

    const url = `${config.avatarServiceApiUrl}/avatar/${userUid}/upload-user-photo?${securityToken}&customizationUid=${customizationUid}`;
    return await tracedFetch('avatarService.uploadUserPhoto', url, { method: 'POST', body: formData });
}
